module.exports = __webpack_public_path__ + "img/head-banner2.0ae7d0de.png";